module.exports = __webpack_public_path__ + "img/9.675b18e8.jpg";